module.exports = __webpack_public_path__ + "img/linkedin.525b7924.png";